import { crudMutations, readOnlyActions } from '../modules/action-helpers'

const basePath = 'api/status'

export default {
  namespaced: true,
  basePath: basePath,
  state: {
    items: [],
    count: 0,
    currentPage: 1,
    currentItem: null,
    expeditionId: 1,
    receptionId: 2
  },
  mutations: {
    ...crudMutations()
  },
  actions: {
    ...readOnlyActions({ basePath: basePath }),
    async list ({ commit, dispatch, state }, data) {
      var params = {}
      params.type = state[data + 'Id']
      return dispatch('list', { basePath: basePath, params: params }, { root: true })
        .then(response => {
          commit('SET_ITEMS', response.results)
          let page = 1
          if (params) {
            page = params.page || 1
          }
          commit('SET_PAGINATION', { count: response.count, currentPage: page })
          return response.results
        })
        .catch(error => {
          throw error
        })
    },
    async reasons ({ dispatch, state }) {
      return dispatch('list', { basePath: `${basePath}/related` }, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    }
  },
  getters: {
    objects (state) { return state.items }
  }
}



// WEBPACK FOOTER //
// ./src/store/masters/status.js